<template>
  <div class="detailCard">
    <div class="detailCard_title">
      {{ title }}
    </div>
    <div class="detailCard_svg">
      <svg width="20" height="20" viewBox="0 0 21 20" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.255 3.998L8.587 14.37 5.35 10.162l-.078-.09-.01-.01a1.084 1.084 0 00-1.62 1.432l4.174 5.427.078.09.01.009c.48.477 1.295.405 1.674-.184l7.508-11.679.057-.104.006-.012a1.083 1.083 0 00-1.894-1.043z"
              fill="#1DC63A"></path>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "detailCard",
  props: {
    title: {
      type: String,
      default:""
    }
  }
}
</script>

<style scoped>

.detailCard {
  width: auto;
  color: black;
  font-size: 12px !important;
  display: inline-block;
  margin: 5px 15px 0 5px;
}

.detailCard_title {
  display: inline-block;
  min-width: 90%;
  max-width: 90%;
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
  align-items: center;
  text-align: left;
  overflow: hidden;
  height: 100%;
}

.detailCard_svg {
  display: inline-block;
  vertical-align: middle;
  width: 10%;
  height: 100%;
}

</style>
